import { useAuthUser } from '@/modules/Auth'
import { GradeForecastType } from '@/modules/Me'

export const useAuthUserGradeStatus = () => {
  const { authUser } = useAuthUser()

  if (!authUser || !authUser.progress) return null

  const { lowerGrade, currentGrade, upperGrade, forecast, fluctuateFactor } =
    authUser.progress

  const usageNumUntilNextGrade =
    (upperGrade?.monthlyReservationNumToAchieve ?? 0) -
    (fluctuateFactor?.monthlyReservationNum ?? 0)
  const usageNumToKeepGrade =
    (currentGrade?.monthlyReservationNumToKeep ?? 0) -
    (fluctuateFactor?.monthlyReservationNum ?? 0)
  const isForecastKeep = forecast === GradeForecastType.KEEP
  const isForecastDown = forecast === GradeForecastType.DOWN
  const isForecastUp = forecast === GradeForecastType.UP

  return {
    usageNumUntilNextGrade,
    usageNumToKeepGrade,
    lowerGrade,
    currentGrade,
    upperGrade,
    fluctuateFactor,
    forecast,
    isForecastKeep,
    isForecastDown,
    isForecastUp,
  }
}
